import { render } from "./NewSIMSPage.vue?vue&type=template&id=9bd9bf0e"
import script from "./NewSIMSPage.vue?vue&type=script&lang=js"
export * from "./NewSIMSPage.vue?vue&type=script&lang=js"

import "./NewSIMSPage.vue?vue&type=style&index=0&id=9bd9bf0e&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__